/* src/app/auth/components/register-form/register-form.component.scss */
:host {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.register-form {
  width: 350px;
}
@media (max-width: 767.98px) {
  .register-form {
    width: 100%;
  }
}
.register-form .phone-field-container {
  display: flex;
}
.register-form .phone-field-container .prefix-field {
  width: 57px;
  margin-right: 5px;
}
.register-form .hide-password-icon {
  cursor: pointer;
  position: relative;
  top: 0;
  left: 3px;
}
.register-form .terms-check-field {
  padding-bottom: 10px;
}
.register-form .terms-check-field > div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.register-form .terms-check-field .terms-links {
  flex-direction: column;
  align-items: center;
}
.account-admin-method {
  text-align: center;
}
/*# sourceMappingURL=register-form.component.css.map */
